import styles from "../IntegrationWheel.module.scss";

export default function WebGazerLogo() {
  return (
    <svg fill="none" height="270" viewBox="0 0 296 295" width="270" xmlns="http://www.w3.org/2000/svg">
      <path
        className={styles.wheelBaseStrokeColor}
        d="M295.063 147.676C295.063 228.559 229.166 294.132 147.873 294.132C66.5792 294.132 0.681891 228.559 0.681891 147.676C0.681891 66.7929 66.5792 1.21998 147.873 1.21998C229.166 1.21998 295.063 66.7929 295.063 147.676Z"
        fill="#43A9C3"
        fillOpacity="0.02"
        strokeWidth="0.959485"
      />

      <g filter="url(#integrations-wheel-webgazer-logo-filter)">
        <path
          className="text-white"
          d="M114.508 159.144L114.508 159.144L136.011 180.648L137.005 179.654L136.011 180.648C142.993 187.629 154.312 187.629 161.294 180.648L160.3 179.654L161.294 180.648L182.798 159.144L181.804 158.151L182.798 159.144C189.779 152.163 189.779 140.843 182.798 133.861L161.294 112.358L161.294 112.358C154.312 105.376 142.993 105.376 136.011 112.358L114.508 133.861L114.508 133.861C107.526 140.843 107.526 152.163 114.508 159.144Z"
          fill="url(#paint0_linear_0_1)"
          stroke="currentColor"
          strokeWidth="2.81137"
        />

        <path
          d="M181.805 134.853L174.657 127.707C171.197 129.479 168.295 132.172 166.268 135.488C164.241 138.804 163.168 142.616 163.168 146.502C163.168 150.389 164.241 154.2 166.268 157.516C168.295 160.833 171.197 163.525 174.657 165.297L181.805 158.149C188.21 151.704 188.21 141.298 181.805 134.853Z"
          fill="url(#integrations-wheel-webgazer-eye-color)"
        />
      </g>

      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="98.4405"
          id="integrations-wheel-webgazer-logo-filter"
          width="98.4419"
          x="99.4316"
          y="104.311"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="7.02841" />
          <feGaussianBlur stdDeviation="4.21705" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_0_1" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_0_1" mode="normal" result="shape" />
        </filter>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_0_1" x1="84.0715" x2="148.578" y1="146.673" y2="211.18">
          <stop stopColor="#117BBF" />
          <stop offset="0.07" stopColor="#1B85C0" />
          <stop offset="0.29" stopColor="#369DC2" />
          <stop offset="0.52" stopColor="#49AFC3" />
          <stop offset="0.75" stopColor="#54BAC4" />
          <stop offset="1" stopColor="#58BDC4" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="integrations-wheel-webgazer-eye-color"
          x1="163.177"
          x2="186.61"
          y1="165.29"
          y2="165.29"
        >
          <stop stopColor="#117BBF" stopOpacity="0.6" />
          <stop offset="0.58" stopColor="#43A9C3" stopOpacity="0.88" />
          <stop offset="0.85" stopColor="#58BDC4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
